
export default {
    FreeTest: {
        GET_CMS_TOKEN: {
            url: (testID) => `/user/wl-login/`,
            method: "GET",
            params: []
        },
        GET_TESTLIST: {
            url: (payload) => {
                let search = "";
                if(payload.search) search = `&search=${payload.search}`;
                return `/shared-test/sharable-list?limit=${payload.limit}&offset=${payload.offset}${search}`;
            },
            method: "GET",
            params: []
        },
        GET_FREE_TESTLIST: {
            url: (payload) => {
                let search = "";
                if(payload.search) search = `&search=${payload.search}`;
                return `/shared-test/list?limit=${payload.limit}&offset=${payload.offset}${search}`
            },
            method: "GET",
            params: []
        },
        GET_TEST_DETAILS: {
            url: testId => `/shared-test/test/${testId}`,
            method: "GET",
            params: []
        },
        UPDATE_SHARE_TEST: {
            url: testId =>  `/shared-test/update/${testId}`,
            // url: () => `/v3/user/sendOTP`,
            method: "PATCH",
            params: []
        },
        CREATE_SHARE_TEST: {
            url: () => `/shared-test/create`,
            method: "POST",
            params: []
        },
        REGISTER_USER: {
            url: () => `/v2/users/register`,
            method: "POST",
            params: []
        },
        FETCH_TEST_STATS: {
            url: () => `/stats/test`,
            method: "GET",
            params: []
        }
    }
};
